import { Tabs, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import BOActivityLogList from '../components/BOActivityLogList';
import BOUserList from '../components/BOUserList';
import { BoUserEnum } from '../../../enums/boUser';
import { PermissionEnum } from '../../../enums/permission';
import usePermission from '../../../hooks/usePermission';
import { PageUtils } from '../../../utils/page';

export const tabProperties = [
  {
    index: 0,
    name: BoUserEnum.tabName.admin,
    permission: PermissionEnum.code.rearrangeViewPackageCategory,
  },
  {
    index: 1,
    name: BoUserEnum.tabName.adminActivity,
    permission: PermissionEnum.code.rearrangeViewCourseCategory,
  },
];

const BoUserList: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [tabs, setTabs] = useState<PageUtils.TabType[]>([]);
  const { checkPermission } = usePermission();
  const handleChangeTab = (value: number): void => {
    setIndex(value);
  };

  const initTab = (): void => {
    const accessibleTab: PageUtils.TabType[] = [];
    tabProperties.forEach((tab) => {
      if (checkPermission([tab.permission])) {
        const { permission, ...data } = tab;
        accessibleTab.push(data);
      }
    });
    setTabs(accessibleTab);
  };
  useEffect(() => {
    initTab();
  }, []);

  return (

    <div>
      <Typography.Title level={3} style={{ fontWeight: 'bold' }}>
        Admin account
      </Typography.Title>
      <div style={{ marginTop: 32 }} />
      <Tabs
        activeKey={`${index}`}
        onChange={(value) => handleChangeTab(Number(value))}
        items={tabs.map((tab) => ({
          key: `${tab.index}`,
          label: tab.name,
        }))}
      />
      {index === 0 && <BOUserList />}
      {index === 1 && <BOActivityLogList />}
    </div>

  );
};

export default BoUserList;
